"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCommitTxData = createCommitTxData;
const bitcoin = __importStar(require("bitcoinjs-lib"));
function toXOnly(pubkey) {
    return pubkey.subarray(1, 33);
}
function createCommitTxData(network, publicKey, inscription) {
    const xOnlyPublicKey = toXOnly(publicKey);
    const script = inscription.toScript(xOnlyPublicKey);
    const outputScript = bitcoin.script.compile(script);
    const scriptTree = {
        output: outputScript,
        redeemVersion: 192,
    };
    const scriptTaproot = bitcoin.payments.p2tr({
        internalPubkey: xOnlyPublicKey,
        scriptTree,
        redeem: scriptTree,
        network,
    });
    const cblock = scriptTaproot.witness?.[scriptTaproot.witness.length - 1];
    const tapLeafScript = {
        leafVersion: scriptTaproot.redeemVersion,
        script: outputScript,
        controlBlock: cblock,
    };
    return {
        scriptTaproot,
        tapLeafScript,
    };
}
